import { XCircle } from 'lucide-react'
import { PiX } from 'react-icons/pi'
import styled, { css } from 'styled-components/macro'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export const FilterChipContainer = styled.span.attrs({
  'data-filter-chip': 'true',
})<{
  $isExclusive?: boolean
  isHovered?: boolean
}>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  color: #087443;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 4px;
  background: #e5ece7;
  height: 40px;
  border: 1px solid transparent;
  box-sizing: border-box;

  b {
    font-weight: 600;
  }

  ${({ $isExclusive }) =>
    $isExclusive &&
    css`
      background: #ffe8ea;
      color: #9c1f2f;
    `}

  ${({ isHovered, $isExclusive }) =>
    isHovered &&
    !$isExclusive &&
    css`
      background: #f4f7f5;
      border: 1px solid #c1d1c6;
      color: #06512f;
    `}

  ${({ isHovered, $isExclusive }) =>
    isHovered &&
    $isExclusive &&
    css`
      background: #ffeeef;
      border: 1px solid #fbdddf;
      color: #9c1f2f;
    `}

  @media (max-width: 768px) {
    height: 24px;
    font-size: 12px;
    line-height: 24px;
  }
`

const StyledXCircle = styled(XCircle)<{ $isExclusive?: boolean }>`
  color: ${(props) => (props.$isExclusive ? '#9C1F2F' : '#087443')};
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
`

// DS2026 (Targets-page) variant: simpler X glyph with a hover-bg "chip" so
// it feels interactive. Hover bg gets bumped to a darker basil shade via
// scoped CSS in main.css so it pops against the chip's own basil-tinted bg.
const StyledPiX = styled(PiX)<{ $isExclusive?: boolean }>`
  color: ${(props) => (props.$isExclusive ? '#9C1F2F' : '#087443')};
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 9999px;
  padding: 1px;
  transition: background-color 120ms;

  &:hover {
    background-color: ${(props) =>
      props.$isExclusive ? '#fbdddf' : '#d2f9de'};
    color: ${(props) => (props.$isExclusive ? '#7a1421' : '#065c34')};
  }
`

export function FilterChipCloseButton(props: {
  $isExclusive?: boolean
  onClick?: (e: React.MouseEvent<SVGElement>) => void
  style?: React.CSSProperties
  className?: string
}) {
  const variant = useTableLinkVariant()
  if (variant === 'plain') {
    return <StyledPiX {...props} />
  }
  return <StyledXCircle {...props} />
}
